











      
import Vue from 'vue'  
import Component from 'vue-class-component'
import moment from 'moment' 

const buildDefaultDates = (startDate:Date = new Date()) => {          
        const start = moment.utc(`${startDate.getUTCFullYear()}-${(startDate.getUTCMonth()+1).toString().padStart(2,'0')}-01T00:00:00.0000000`)          
        return [start.toDate(),start.add(1,"month").toDate()]                  
      }

@Component({
  name: 'MonthPicker',     
  props:{              
    from:{
      type:Date,
      default:() => {
        const now = new Date()
        const start = moment.utc(`${now.getUTCFullYear()}-${(now.getUTCMonth()+1).toString().padStart(2,'0')}-01T00:00:00.0000000`)          
        return start.add(-1,"year").toDate()
      }
    },
    value:{
      type:Date,
      default:()=>{return new Date()}
    }
  }
})
export default class MonthPicker extends Vue {  
      
  private value!:Date
  private dates = buildDefaultDates(this.value)    
  private from!:Date            
  private allYear = false 

  mounted(){
    this.monthChanged()
  }

  monthChanged(){
    const newDate = new Date(this.dates[0]);
    if(this.allYear) newDate.setUTCDate(31)
    this.$emit("input",newDate)
    this.$emit("monthChange",this.dates)            
  }

  selectAllYear() {
    this.allYear = true
    const start = moment.utc(`${this.year}-01-01T00:00:00.0000000`)      
    this.$set(this,"dates", [start.toDate(),start.add(12,"month").toDate()])
    this.monthChanged()
  }
  
    
  get minDates() {      
    const start = moment.utc(`${this.from.getUTCFullYear()}-${(this.from.getUTCMonth()+1).toString().padStart(2,'0')}-01T00:00:00.0000000`)          
    return [start.toDate(),start.add(1,"month").toDate()] 
  }

  get maxDates() {      
    return buildDefaultDates()
  }

  get years() {
    const now = new Date()
    const fromYear = this.from.getUTCFullYear()
    return [...Array(now.getUTCFullYear()-fromYear+1).keys()].map(y => y+fromYear)
  }

  get months() {
    return [...Array(12).keys()].map(m => m+1)
  }
  
  get year(){   
    return this.dates.length == 2?       
          this.dates[0].getUTCFullYear()
        : this.maxDates[0].getUTCFullYear()
  }

  set year(newYear) {      
    const start = moment.utc(`${newYear}-${(this.dates[0].getUTCMonth()+1).toString().padStart(2,'0')}-01T00:00:00.0000000`)                
    let newVal = [start.toDate(),start.add(this.allYear?12:1,"month").toDate()]      
    if(!this.allYear){
      if(newVal[0] < this.minDates[0]) newVal = this.minDates
      if(newVal[0] > this.maxDates[0]) newVal = this.maxDates
    }
    this.$set(this,"dates",newVal)
    this.monthChanged()
  }

  get month() {      
    return this.dates.length == 2?       
          this.dates[0].getUTCMonth()+1
        : this.maxDates[0].getUTCMonth()+1      
  }

  set month(newMonth) {      
    this.allYear = false
    const start = moment.utc(`${this.year}-${newMonth.toString().padStart(2,'0')}-01T00:00:00.0000000`)                
    this.$set(this,"dates",[start.toDate(),start.add(1,"month").toDate()])
    this.monthChanged()
  }
}
